/** Main ops admin (Vite). Override with `REACT_APP_ADMIN_PORTAL_URL` (full URL, e.g. …/login). */
const adminPortalFromEnv =
  typeof process !== "undefined" && process.env.REACT_APP_ADMIN_PORTAL_URL
    ? String(process.env.REACT_APP_ADMIN_PORTAL_URL).trim().replace(/\/$/, "")
    : "";
export const ADMIN_PORTAL_LOGIN_URL = adminPortalFromEnv || "https://admin.wateriia.com/login";

export function getAdminPortalLoginUrl() {
  return ADMIN_PORTAL_LOGIN_URL;
}

/** Store listings of the customer app; QR codes for them live in /public (app-qr-*.svg). */
export const APP_LINKS = {
  ios: "https://apps.apple.com/in/app/wateriia-app/id6803549106",
  android: "https://play.google.com/store/apps/details?id=co.wateriia.app",
};

export const SITE = {
  brand: "Wateriia",
  brandSuffix: "India",
  city: "Bengaluru",
  region: "Karnataka",
  country: "India",
  tagline: "Pure Water. Delivered Smarter.",
  subtagline: "Reliable, technology-driven water supply solutions across Bengaluru — now at your fingertips.",
  phoneDisplay: "+91 94499 82902",
  phoneTel: "+919449982902",
  email: "info@wateriia.com",
  address: "No 31, Brindavan Nagar, HMT Main Rd, SBM Colony, Mathikere, Bengaluru, Karnataka 560054",
  shortAddress: "Mathikere, Bengaluru 560054",
  mapsLink: "https://maps.google.com/?q=No+31+Brindavan+Nagar+HMT+Main+Rd+SBM+Colony+Mathikere+Bengaluru+560054",
  logo: "/wateriia-logo.png",
};
